import React from "react";
import { Addon } from "./Addons";
import { useProductOutput } from "stores/product";

export const ProductAddonSuggestions = () => {
  const productOutput = useProductOutput();
  const listViewConfigurations = productOutput?.product?.listViewConfiguration;

  return (
    <div
      className="mb-4 d-grid"
      style={{
        gridTemplateColumns: "1fr 1fr",
        gap: "1rem",
      }}
    >
      {listViewConfigurations?.accessories?.map((accessory, key) =>
        accessory ? <Addon key={key} addonItem={accessory} /> : <></>,
      )}
      {listViewConfigurations?.attachments?.map((attachment, key) =>
        attachment ? <Addon key={key} addonItem={attachment} /> : <></>,
      )}
    </div>
  );
};
